import { ConnectorGlyph } from '@/components/points/ConnectorGlyph';
import { formatConnectorType } from '@/api/points';
import type { ConnectorTypeGroup } from '@/lib/connectorGroups';

interface Props {
  group: ConnectorTypeGroup;
  onOpen: () => void;
}

/** Quadrado tocável de tipo de conector — resumo por tipo da estação com
 * vários carregadores (feedback Saulo 2026-07-07, mapfirst-multi-noscroll.jsx
 * · G · `TipoTile`). Tocar abre o detalhamento filtrado por esse tipo. */
export function TypeTile({ group, onOpen }: Props) {
  const has = group.free > 0;
  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex min-w-0 flex-1 flex-col gap-3 rounded-[20px] border-[1.5px] bg-white p-3.5 text-left"
      style={{
        borderColor: has ? 'rgba(0,192,114,0.35)' : 'rgba(0,27,116,0.08)',
        boxShadow: has ? '0 2px 10px rgba(0,192,114,0.12)' : '0 1px 2px rgba(0,27,116,0.04)'
      }}
    >
      <div className="flex items-center justify-between gap-1">
        <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-bow-cream-2/70 text-bow-royal">
          <ConnectorGlyph type={group.type} size={19} />
        </span>
        <div className="flex-1 text-center">
          <div className="text-[17px] font-semibold leading-none tracking-tight text-bow-royal">
            {Math.round(group.maxKw)} kW
          </div>
          <div className="mt-1.5 text-[11.5px] font-semibold text-bow-royal/50">
            {formatConnectorType(group.type)}
          </div>
        </div>
        <ChevronRight />
      </div>
      <div className="flex items-baseline justify-center gap-1.5">
        <span
          className="text-[28px] font-bold leading-none tracking-tight"
          style={{
            fontFamily: 'Chillax, system-ui, sans-serif',
            color: has ? '#00A664' : 'rgba(0,27,116,0.5)'
          }}
        >
          {group.free}
        </span>
        <span className="text-[12px] font-semibold text-bow-royal/50">
          de {group.total} {group.free === 1 ? 'livre' : 'livres'}
        </span>
      </div>
    </button>
  );
}

function ChevronRight() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-bow-royal/30"
      aria-hidden
    >
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}
